import { css } from 'styled-components';
import { accent } from '../../tokens';
import { fieldStatuses } from '../Field';
export var applyInputStyles = function applyInputStyles(_ref) {
  var status = _ref.status,
      _ref$$size = _ref.$size,
      $size = _ref$$size === void 0 ? 'm' : _ref$$size;
  return css(["box-sizing:border-box;width:100%;border:0 none;caret-color:", ";font:inherit;line-height:inherit;letter-spacing:inherit;&:focus{outline:none;}&:disabled{cursor:inherit;}&[readonly]{cursor:default;}", ""], status ? fieldStatuses[status] : accent, $size === 'l' ? css(["height:3.5rem;padding:1.125rem 1rem;&:not(:placeholder-shown){padding-top:1.5rem;padding-bottom:0.375rem;}&::placeholder{color:transparent;}"]) : css(["height:3rem;padding:0.875rem 1rem;"]));
};